module.exports = __webpack_public_path__ + "img/eu.cb462712.svg";